function initMediaZoomCursor() {
  const hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');

  document.querySelectorAll('.product__modal-opener--image').forEach((opener) => {
    const icon = opener.querySelector('.product__media-icon--fullscreen');
    if (icon && hoverCapable.matches) {
      opener.addEventListener('mousemove', (event) => {
        const rect = opener.getBoundingClientRect();
        icon.style.left = `${event.clientX - rect.left}px`;
        icon.style.top = `${event.clientY - rect.top}px`;
      });
    }

    /* global.js's ModalOpener listens on the nested <button>, but on this
       layout a real click's target ends up being <modal-opener> itself (per
       DevTools) — an ancestor of the button, so it never bubbles down to
       trigger that listener. Bind directly here as well. */
    const button = opener.querySelector('.product__media-toggle');
    const modalSelector = opener.getAttribute('data-modal');
    if (!button || !modalSelector) return;

    if (hoverCapable.matches) opener.style.cursor = 'none';
    opener.addEventListener('click', () => {
      const modal = document.querySelector(modalSelector);
      if (modal) modal.show(button);
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMediaZoomCursor);
} else {
  initMediaZoomCursor();
}
